import type { ReactNode } from "react";

import { GoldfinchLogo } from "@/packages/ui/goldfinch/logo";
import { PrivacyChoicesLink } from "@/packages/ui/legal/PrivacyChoicesLink";
import { AppLink } from "@/ui/app-link/app-link";

const productLinks = [
  { href: "/life-insurance", label: "Life Insurance" },
  { href: "/annuities", label: "Annuities" },
  { href: "/annuity/rates", label: "Compare Annuity Rates" },
  { href: "/learn", label: "Learn" },
  { href: "/quiz", label: "Coverage Quiz" },
];

const companyLinks = [
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
  { href: "/privacy", label: "Privacy" },
  { href: "/terms", label: "Terms" },
];

function FooterLinkGroup(props: {
  title: string;
  links: { href: string; label: string }[];
  extra?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-3">
      <span className="font-mono text-[10px] uppercase tracking-[3px] text-v2-gold">
        {props.title}
      </span>
      {props.links.map((link) => (
        <AppLink
          key={link.href}
          href={link.href}
          className="text-sm text-v2-cream/40 transition-colors duration-200 hover:text-v2-cream">
          {link.label}
        </AppLink>
      ))}
      {props.extra}
    </div>
  );
}

export function SiteFooter() {
  return (
    <footer className="v2-dark-textured bg-v2-black text-v2-cream">
      <div className="mx-auto max-w-6xl px-6 py-14 md:px-10 md:py-20">
        <div className="flex flex-col gap-10 md:flex-row md:justify-between">
          <div className="flex flex-col gap-4">
            <GoldfinchLogo className="h-8 w-auto text-v2-cream" />
            <p className="max-w-sm text-sm leading-relaxed text-v2-cream/30">
              &copy; 2026 Goldfinch Solutions Inc. d/b/a Goldfinch Insurance
              Solutions and Goldfinch Insurance Agency
            </p>
          </div>

          <div className="flex gap-16">
            <FooterLinkGroup title="PRODUCTS" links={productLinks} />
            <FooterLinkGroup
              title="COMPANY"
              links={companyLinks}
              extra={
                <PrivacyChoicesLink className="text-sm text-v2-cream/40 transition-colors duration-200 hover:text-v2-cream" />
              }
            />
          </div>
        </div>

        <div className="mt-14 border-t border-v2-cream/[0.04] pt-6">
          <p className="font-mono text-[10px] tracking-wider text-v2-cream/20">
            &copy; 2026 Goldfinch Solutions Inc. d/b/a Goldfinch Insurance
            Solutions and Goldfinch Insurance Agency
          </p>
        </div>
      </div>
    </footer>
  );
}
